import { IButtonStyles, ILabelStyles } from 'office-ui-fabric-react';
import { AppLayoutSettings } from '../../common/styles/common.styles';

export const getBottomLabelStyles = (): ILabelStyles => {
  return AppLayoutSettings.AppCommonStyles.getRegularLabelStyles(AppLayoutSettings.AppFontSize.mediumFontSizePx,  AppLayoutSettings.getAppColorContainer().mediumLabelColor);
};

export const getRecordingButtonCustomStyles = (): Partial<IButtonStyles> => {
  return {
    root: {
      selectors: {
        [`:focus`]: {
          border: '1px solid transparent',
          outline: '1px solid',
          outlineColor: AppLayoutSettings.getAppColorContainer().keyboardFocusColor.value
        }
      }
    }
  };
};

